import { http } from '@/shared/api/axios';
import type { CredentialCompliance } from '../model/types';

export const credentialComplianceApi = {
  forEmployee: async (employeeId: number): Promise<CredentialCompliance> => {
    const { data } = await http.get<CredentialCompliance>(
      `/v1/employees/${employeeId}/credential-compliance`
    );
    return data;
  },
};
